export default "__VITE_ASSET__Bhtn6gYJ__"